/**
 * SimpleAccount — the Account screen while Simple view is on (#476): the
 * Simple view switch as the first row, who is signed in, and Sign out.
 * Every other Account setting stays in the full view, one tap away.
 *
 * Author: Maré Greyling (Thevertex) <mare.greyling@gmail.com> — https://mare-greyling.com
 */
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../App.jsx';
import SimpleShell from './SimpleShell.jsx';
import { Icon, SimpleViewSetting } from './viewMode.jsx';

export default function SimpleAccount() {
  const { me, logout } = useAuth();
  const nav = useNavigate();
  const who = `${me?.first_name || ''} ${me?.last_name || ''}`.trim() || me?.email || '';
  return (
    <SimpleShell active="account">
      <main className="sv-main">
        <div className="sv-form sv-fade">
          <button type="button" className="sv-ghost sv-back" onClick={() => nav('/app')}>{Icon.back}Home</button>
          <h1 className="sv-h1 big">Account</h1>
          <SimpleViewSetting />
          <div className="sv-plain">
            <div style={{ overflowWrap: 'anywhere' }}>Signed in as {who}</div>
            <button type="button" onClick={logout}>Sign out</button>
          </div>
        </div>
      </main>
    </SimpleShell>
  );
}
